export default class ParcelaAntecipacaoSienge {
    billId: number;
    installmentId: number;

    constructor(billId: number, installmentId: number) {
        this.billId = billId;
        this.installmentId = installmentId;
    }
}
